import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
const faqs = [{
  question: '¿Sirve si mi Frenchie come croquetas?',
  answer: 'Sí. También funciona si das húmeda o comida cocida. El sistema se adapta a tu forma de alimentar sin improvisar.'
}, {
  question: '¿Cuánto tiempo toma al día?',
  answer: '5 a 10 minutos al día. El meal prep es una sola vez por semana y toma alrededor de 20 minutos.'
}, {
  question: '¿Esto reemplaza al veterinario?',
  answer: 'No. Si hay vómito frecuente, sangre o dolor, primero veterinario. Esto te da estructura diaria para tomar mejores decisiones.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-gradient-to-b from-[#FDF4FF] via-[#FAE8FF] to-[#FDF4FF] relative overflow-hidden" data-id="element-97">
      {/* Decorative elements */}
      <div className="absolute top-10 left-10 w-32 h-32 bg-[#D946EF]/10 rounded-full blur-3xl" data-id="element-98" />
      <div className="absolute bottom-10 right-10 w-40 h-40 bg-[#F0ABFC]/20 rounded-full blur-3xl" data-id="element-99" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl relative z-10" data-id="element-100">
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-101">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#D946EF]/10 text-[#A21CAF] text-sm font-semibold mb-4" data-id="element-102">
            <div className="w-4 h-4" data-id="element-103" />
            Resolvemos tus dudas
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D2D2D] mb-4" data-id="element-104">
            Preguntas frecuentes
          </h2>
          <p className="text-[#666666]" data-id="element-105">
            Respuestas claras para comprar con confianza.
          </p>
        </motion.div>

        <div className="space-y-4" data-id="element-106">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`rounded-2xl overflow-hidden shadow-lg transition-all duration-300 ${openIndex === index ? 'bg-white ring-2 ring-[#D946EF] shadow-[#D946EF]/20' : 'bg-white/80 backdrop-blur-sm hover:bg-white hover:shadow-xl'}`} data-id="element-107">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-108">
                <div className="flex items-center gap-4" data-id="element-109">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center transition-colors duration-300 ${openIndex === index ? 'bg-[#D946EF] text-white' : 'bg-[#FAE8FF] text-[#D946EF]'}`} data-id="element-110">
                    <HelpCircle className="w-5 h-5" data-id="element-111" />
                  </div>
                  <span className="font-bold text-[#2D2D2D] text-lg" data-id="element-112">
                    {faq.question}
                  </span>
                </div>
                <div className={`w-8 h-8 rounded-full flex items-center justify-center transition-all duration-300 ${openIndex === index ? 'bg-[#D946EF] text-white rotate-180' : 'bg-[#FAE8FF] text-[#D946EF]'}`} data-id="element-113">
                  <ChevronDown className="w-5 h-5" data-id="element-114" />
                </div>
              </button>

              <AnimatePresence data-id="element-115">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-116">
                    <div className="px-6 pb-6 pl-20 text-[#666666] leading-relaxed" data-id="element-117">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}